export default "__VITE_PUBLIC_ASSET__732cb7da__"